import { ThemingService } from "./../core/theming/theming.service";
import { SecurityOidcService } from "../core/services/system/security.oidc.service";

import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Languages } from "../_enumerations/languages";
import { TranslateService } from "@ngx-translate/core";
import { SJIAppContextService } from "../core/services/system/sji.appcontext.service";
import { SJIAppContext } from "../core/models/system/sjiappcontext";
import { Router } from "@angular/router";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { MessageService } from "../core/services/system/message.service";
import { APP_CONFIGS } from "../_configs/appconfigs";

declare var window: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: [
    "../themes/OneUI/all.scss",
    "./app.component.scss",
    "../../assets/scss/font-awesome.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SJIAppComponent implements OnInit {
  loaded = false;
  loggedIn = false;
  sjiAppContext: SJIAppContext = new SJIAppContext();
  idleState = "Not started.";
  // Work for Idle process.
  isTimeout = false;
  // Chatbot visibility control
  isChatbotVisible = false;
  // Check if current company is DTI (CompanyId = 2)
  isDTICompany = false;
  // Track whether Web Chat CDN script has been loaded
  private webChatScriptLoaded = false;
  // Debounce timer for Web Chat re-initialization to prevent multiple rapid calls
  private webChatReinitTimer: any = null;
  // Check if current company is Maxam NA (CompanyId = 13)
  isMaxamNACompany = false;


  // title = 'Dapasoft Angular 5 template';
  // enableDynamicTheme = APP_CONFIGS.enableDynamicTheme;
  // tslint:disable-next-line:max-line-length
  constructor(
    private translateService: TranslateService,
    private securityService: SecurityOidcService,
    private appContextService: SJIAppContextService,
    private themeService: ThemingService,
    private router: Router,
    private titleService: Title,
    private idle: Idle,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {
    const self = this;
  } // End of construtor.

  /**
   * this reason calling ngOnInit here is
   * we cannot declare a class constructor as async.
   * As a workaround we could take advantage of Angular’s lifecycle methods
   * and move our initialisation code to ngOnInit, marking that method as async.
   *
   */
  async ngOnInit() {
    // console.log('start call sji appComponent async ngOnInit');
    //
    // Call appContextService.init first.
    // Note: Only call one time appContextservice.init here.
    //
    await this.appContextService.initDomain();
    const logonUser = await this.securityService.init();
    console.log(
      "securitySevice.init completed. Logon User: " + JSON.stringify(logonUser)
    );
    this.loggedIn = this.securityService.isLoggedIn();
    console.log("sji appcomponent loggedIn = " + this.loggedIn);
    await this.appContextService.initContext();

    this.sjiAppContext = this.appContextService.getAppContext();
    // Set DTI company flag for chatbot visibility
    this.isDTICompany = this.appContextService.getCompanyId() == "2";
    // Show the Maxam NA chatbot for CompanyId 13, but not for the Dynamaxx
    // portal (domainGroupId = "13_Dynamaxx"), which must not expose it.
    this.isMaxamNACompany =
      this.appContextService.getCompanyId() == "13" &&
      this.appContextService.getDomainGroupId() != "13_Dynamaxx";
    if (this.isDTICompany) {
      // Subscribe to context change events to re-initialize Web Chat.
      // Debounced via scheduleWebChatReinit() so multiple rapid events
      // (e.g. customerChanged + customerShipToChanged) result in a single re-init.
      this.appContextService.customerChanged
        .subscribe(() => this.scheduleWebChatReinit());
      this.appContextService.customerShipToChanged
        .subscribe(() => this.scheduleWebChatReinit());
    }

    if (
      this.sjiAppContext.mobileWebsite &&
      this.sjiAppContext.mobileWebsite.length > 0
    ) {
      const isMobileDevic =
        /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
          navigator.userAgent
        );
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      const isMobile = isMobileDevic && (width <= 768 || height <= 768);
      if (isMobile) {
        window.location.href = this.sjiAppContext.mobileWebsite;
        return;
      }
    }
    //
    // After appContextService.init(), call themingService.init().
    //
    this.themeService.init();

    if (
      location.href.indexOf("auth-callback") > 0 ||
      location.href.indexOf("silent-refresh") > 0
    ) {
      // callback page, we did nothing
      this.loaded = true;
    } else {
      if (!this.loggedIn) {
        // console.log('before call login');
        // User has to login first.
        await this.securityService.login();
      } else {
        this.loaded = true;
      }
    }

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.addLangs([
      Languages.English_US,
      Languages.French_CA,
      Languages.Chinese_CHS,
    ]);
    // this.translateService.setDefaultLang(Languages.English_US);
    // const language = this.securityService.getUserLanguage();
    // this.translateService.getTranslation(language);
    this.translateService.use(this.appContextService.getLanguage());

    if (this.appContextService.getAppContext().isTempPasswordLogin) {
      // If user logined, but he/she is login with temporary password,
      // system will push them to resetpassword page to reset new password first.
      this.router.navigate(["userprofile/resetpassword"]);
    }
    this.titleService.setTitle(this.appContextService.appContext.companyName);

    //
    // Below codes works for force client app logout if idle about 20 minutes.
    //
    let systemIdleTimeout = 20 * 60; // Default 20 minutes idle
    const systemTimeout = 60; // seconds. warning for 60 seconds before apply logout.

    // Adjust the DTI portal timeout to 120 minutes.
    if (this.appContextService.getCompanyId() == "2") {
      systemIdleTimeout = 120 * 60;
    }

    // Set idle and timeout values
    this.idle.setIdle(systemIdleTimeout); // in seconds
    this.idle.setTimeout(systemTimeout); // in seconds
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // Define responses to idle events
    this.idle.onIdleEnd.subscribe(() => this.handleIdleEnd());
    this.idle.onTimeout.subscribe(() => this.handleTimeout());
    this.idle.onIdleStart.subscribe(() => this.handleIdleStart());
    this.idle.onTimeoutWarning.subscribe((countdown) =>
      this.handleTimeoutWarning(countdown)
    );
    this.idle.watch();
  }

  handleIdleEnd() {
    this.idleState = "No longer idle.";
    // Reset logic
    this.reset();
  }

  handleTimeout() {
    this.idleState = "Logout!";
    // Logout logic
    this.securityService.signout();
  }

  handleIdleStart() {
    this.idleState = "You will be logged out soon!";
    // Show warning dialog
  }

  handleTimeoutWarning(countdown) {
    this.isTimeout = true;
    this.idleState = this.translateService
      .instant("Core.IdleMessage")
      .replace("#countdown#", countdown);
  }

  reset() {
    this.idle.watch();
    this.isTimeout = false;
  }

  continueLogin() {
    this.reset();
  }

  toggleChatbot() {
    this.isChatbotVisible = !this.isChatbotVisible;
    if (this.isDTICompany && this.isChatbotVisible) {
      this.initDTIWebChat();
    }
  }

  /**
   * Debounce Web Chat re-initialization. Multiple events (customerChanged, customerShipToChanged)
   * can fire in quick succession for a single user action. This ensures only one
   * re-initialization happens after all events have settled.
   *
   * Panel stays visible during reinit (same as first-load via toggleChatbot) so that
   * WebChat renders into a visible container — it cannot render in a hidden one.
   */
  private scheduleWebChatReinit() {
    if (!this.isChatbotVisible) return;
    if (this.webChatReinitTimer) {
      clearTimeout(this.webChatReinitTimer);
    }
    // Show a loading indicator while we reinitialize.
    // Panel stays visible so WebChat can render into it (same as first-load).
    const webchatElement = document.getElementById('webchat');
    if (webchatElement) {
      webchatElement.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:14px;">Reloading chatbot...</div>';
    }
    // After debounce delay, reinitialize WebChat into the visible panel.
    // initDTIWebChat() creates a fresh DOM element to avoid React residue issues.
    this.webChatReinitTimer = setTimeout(() => {
      this.webChatReinitTimer = null;
      this.initDTIWebChat();
    }, 1000);
  }

  private loadWebChatScript(): Promise<void> {
    if (this.webChatScriptLoaded) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.botframework.com/botframework-webchat/latest/webchat.js';
      script.onload = () => {
        this.webChatScriptLoaded = true;
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  async initDTIWebChat() {
    try {
      await this.loadWebChatScript();

      const tokenResponse: any = await this.http.get(
        APP_CONFIGS.apiRootUrl + 'api/Chatbot/token'
      ).toPromise();
     
      console.log('Token Response:', tokenResponse);

      const dtiToken = tokenResponse.dtiToken || '';
      const claims = this.securityService.getClaims();
      const userName = claims ? claims.name : '';
      const customerID = this.appContextService.getNavCustomerId();
      const companyID = this.appContextService.getCompanyId();

      const appContext = this.appContextService.getAppContext();
      const shipToCode = appContext.navShipToCode || '';

      console.log('[initDTIWebChat] appContext snapshot - companyCustomerCd:', appContext.companyCustomerCd,
        'companyCustomerShippingAddressCd:', appContext.companyCustomerShippingAddressCd,
        'navShipToCode:', appContext.navShipToCode);
      console.log('[initDTIWebChat] Sending to AI chatbot - CustomerID:', customerID, 'CompanyID:', companyID, 'ShipToCode:', shipToCode, 'DTIToken:', dtiToken ? '(present)' : '(empty)');

      const initContextPayload = {
        DTIToken: dtiToken,
        UserName: userName,
        CustomerID: customerID,
        CompanyID: companyID,
        ShipToCode: shipToCode
      };
      console.log('[initDTIWebChat] initContext payload prepared:', JSON.stringify(initContextPayload));

      const store = window.WebChat.createStore({}, ({ dispatch }) => next => action => {
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
          console.log('[initDTIWebChat] DIRECT_LINE/CONNECT_FULFILLED - dispatching initContext with ShipToCode:', shipToCode);
          dispatch({
            type: 'WEB_CHAT/SEND_EVENT',
            payload: {
              name: 'initContext',
              value: initContextPayload
            }
          });
        }
        return next(action);
      });

      // Remove the old #webchat element and create a completely fresh one.
      // Bot Framework WebChat uses React internally — reusing a DOM element that
      // previously had a React root (even after innerHTML='') leaves orphaned
      // virtual DOM state that causes the new render to show a white screen.
      const oldWebchat = document.getElementById('webchat');
      const parent = oldWebchat ? oldWebchat.parentElement : null;
      console.log('[initDTIWebChat] webchat element found:', !!oldWebchat, 'parent found:', !!parent);
      if (oldWebchat && parent) {
        oldWebchat.remove();
        const newWebchat = document.createElement('div');
        newWebchat.id = 'webchat';
        newWebchat.style.width = '100%';
        newWebchat.style.height = 'calc(100% - 40px)';
        parent.appendChild(newWebchat);
        window.WebChat.renderWebChat({
          directLine: window.WebChat.createDirectLine({ token: tokenResponse.token }),
          store: store
        }, newWebchat);
        console.log('[initDTIWebChat] WebChat rendered successfully');
      }
    } catch (error) {
      console.error('Failed to initialize DTI Web Chat:', error);
    }
  }

  close(reason: string) {
    // Handle dialog close
    if (reason === 'dialog') {
      this.reset();
    }
  }
}
